import { render, staticRenderFns } from "./UploadPatch.vue?vue&type=template&id=1256737e&scoped=true&"
import script from "./UploadPatch.vue?vue&type=script&lang=ts&"
export * from "./UploadPatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1256737e",
  null
  
)

export default component.exports